import React, { useState } from "react";
import {
  Container,
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaInstagram, FaFacebook } from "react-icons/fa";

const modalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "500px",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 3,
  maxHeight: "90vh",
  overflowY: "auto", // Enables vertical scrolling
};

const Footer = () => {
  const [openModal, setOpenModal] = useState(null);

  const handleOpenModal = (modal) => setOpenModal(modal);
  const handleCloseModal = () => setOpenModal(null);

  const modalContent = {
    terms: (
      <>
        <Typography variant="body1" sx={{ mt: 2 }}>
          <h2>
            <b>Privacy Policy</b>
          </h2>
          <p>
            This Privacy Policy describes how{" "}
            <a href="https://www.illolam.com/jewels" target="_blank">
              illolam.com
            </a>{" "}
            and its affiliates collect, use, share, protect, or process your
            personal data through our website (hereinafter referred to as the
            "Platform"). You may browse certain sections of the Platform without
            registering; however, by visiting or using our Platform, you agree
            to be bound by this Privacy Policy, the Terms of Use, and applicable
            laws of India, including data protection laws. If you disagree,
            please refrain from accessing the Platform. Your personal data will
            primarily be stored and processed in India, and we do not offer
            products/services under this Platform outside India.
          </p>
          <p>
            We collect your personal data when you interact with our Platform or
            services. This includes but is not limited to your name, date of
            birth, address, contact number, email ID, and identity proof.
            Sensitive personal data, like payment details or biometric
            information, may be collected with your consent. You can choose not
            to provide information, though this may limit access to certain
            features. Additionally, we may track your behavior, preferences, and
            transactions, both on our Platform and partner platforms. Such
            third-party platforms operate under their own privacy policies, and
            we are not responsible for their practices. If you receive
            suspicious requests for sensitive information, report them
            immediately to law enforcement.
          </p>
          <p>
            We may share your personal data within our group entities,
            affiliates, and trusted partners (e.g., logistics, payment
            providers) to deliver our services or comply with legal obligations.
            Disclosure may occur to prevent fraud, enforce policies, or respond
            to lawful requests from government agencies. We adopt reasonable
            security practices to protect your personal data from unauthorized
            access. However, as data transmission over the internet can never be
            fully secure, users are responsible for safeguarding their login
            credentials and acknowledging the risks inherent to online data
            sharing.
          </p>
          <p>
            You can request account deletion via your profile settings or by
            contacting us. We may delay deletion if pending claims or grievances
            exist. Retained data will only be kept for as long as necessary for
            legitimate purposes or as required by law. Anonymized data may be
            used for research and analysis. By using our Platform or providing
            information, you consent to the collection, use, and sharing of your
            data per this Privacy Policy. You can withdraw consent by writing to
            our Grievance Officer with the subject line "Withdrawal of consent
            for processing personal data." Significant updates to this Privacy
            Policy will be communicated in compliance with applicable laws.
          </p>
        </Typography>
      </>
    ),
    cancellation: (
      <>
        <h2>
          <b>Terms of Use</b>
        </h2>

        <p>
          This document is an electronic record in terms of the Information
          Technology Act, 2000, and rules thereunder, as applicable, along with
          the amended provisions pertaining to electronic records. This
          electronic record is generated by a computer system and does not
          require any physical or digital signatures. This document is published
          in accordance with Rule 3(1) of the Information Technology
          (Intermediaries Guidelines) Rules, 2011, which requires publishing the
          rules, privacy policy, and Terms of Use for accessing or using the
          domain name{" "}
          <a href="https://www.illolam.com/jewels" target="_blank">
            illolam.com
          </a>{" "}
          (hereinafter referred to as the "Platform"). The Platform is owned and
          operated by Anjana Asok, an individual business owner (hereinafter
          referred to as the "Platform Owner," "I," "me," or "my"). By
          accessing, browsing, or using the Platform, you agree to be bound by
          these Terms of Use, applicable policies, and any modifications made
          over time.
        </p>

        <p>
          Your use of the Platform and its services is at your own risk, and we
          do not provide any warranty regarding the accuracy, timeliness, or
          completeness of the information provided. Unauthorized use of the
          Platform may result in actions against you under applicable laws. You
          agree not to use the Platform for any illegal, unlawful, or forbidden
          purposes. By initiating a transaction, you enter into a legally
          binding contract with the Platform Owner. You shall indemnify and hold
          harmless the Platform Owner, its affiliates, employees, and directors
          from any claims or actions arising from your breach of these Terms of
          Use or violation of laws or third-party rights. You also acknowledge
          that links to third-party websites provided on the Platform are for
          convenience, and accessing these links will subject you to their terms
          and policies.
        </p>

        <p>
          In no event shall the Platform Owner be liable for indirect,
          consequential, or incidental damages, including loss of profits,
          business opportunities, or data. Liability will not exceed the amount
          paid for using the services or INR 100, whichever is less. Neither
          party shall be liable for failure to perform obligations due to a
          force majeure event. These Terms of Use are governed by the laws of
          India, and any disputes will be subject to the exclusive jurisdiction
          of the courts in Thiruvananthapuram, Kerala. All communications
          regarding these Terms must be directed to the contact information
          provided on the Platform.
        </p>
      </>
    ),
    shipping: (
      <>
        <h2>
          <b>Shipping Policy</b>
        </h2>
        <p>
          Orders require up to 3 business days for processing before dispatch. Once shipped, all orders are typically delivered within 7–8 business days. 
          Orders are not shipped or delivered on weekends or holidays. If we are experiencing a
          high volume of orders, shipments may be delayed by a few days. Please
          allow additional days in transit for delivery. If there will be a
          significant delay in the shipment of your order, we will contact you
          via email or phone. Please note that delivery times may be affected by factors beyond our
          control, such as weather conditions, customs delays, and other
          unforeseen circumstances.
        </p>
      </>
    ),
    returnpolicy: (
      <>
        <h2>
          <b>Return and Refund policy</b>
        </h2>
        <p>
          Return & Refund policy: Customers can request a return or refund
          within 7 business days from the date of purchase. This ensures ample
          time for customers to assess their purchases and initiate returns if
          necessary. We will notify you once we’ve received and inspected your
          return, and let you know if the refund was approved or not within 5
          business days.
        </p>
        <p>
          Refund processing: We ensure quality product and expect quality
          returns. After approval, refund processing may take up to 5 business days before initiation.
           Once approved, the refund will be automatically processed and credited to your original payment method within 10 business days. Please remember
          it can take some time for your bank or credit card company to process
          and post the refund too. If more than 15 business days have passed
          since we’ve approved your return, please contact us using the details
          present at Contact Us.
        </p>
      </>
    ),
    contact: (
      <>
        <h2>
          <b>Contact Us</b>
        </h2>
        <p>
          If you have any questions, concerns, or require further assistance
          regarding these Terms of Use, please feel free to contact us.
        </p>
        <p>
          You can reach out to us via phone at{" "}
          <a href="tel:+917907448913">+91 7907448913</a> or email us at{" "}
          <a href="mailto:illolam.anjana@gmail.com">illolam.anjana@gmail.com</a>
          . We will make every effort to address your queries in a timely
          manner.
        </p>
        <p>
          <b>Address:</b> <br />
          Anjana Asok, <br />
          VP 2 / 481A, Perukavu, <br />
          Trivandrum, Kerala - 695573
        </p>
      </>
    ),
  };

  return (
    <Container maxWidth="xxl">
      <footer style={styles.footer}>
        <div style={styles.line}></div>
        <div style={styles.iconsRow}>
          <a
            href="https://www.instagram.com/illolam_jewels"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.iconLink}
          >
            <FaInstagram style={styles.icon} />
            <span>@illolam_jewels</span>
          </a>
          <a
            href="https://www.facebook.com/people/Illolam-Jewels/61559592766690/?mibextid=LQQJ4d&rdid=pBtYjBOnHlX8AGqj&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15JjVZRf2a%2F%3Fmibextid%3DLQQJ4d"
            rel="noopener noreferrer"
            style={styles.iconLink}
          >
            <FaFacebook style={styles.icon} />
          </a>
        </div>
        <Grid container spacing={0}>
          {/* First Row */}
          <Grid item xs={6} lg={3}>
            <Button
              onClick={() => handleOpenModal("terms")}
              variant="text"
              sx={{ textTransform: "none" }}
            >
              Privacy Policy
            </Button>
          </Grid>
          <Grid item xs={6} lg={3}>
            <Button
              onClick={() => handleOpenModal("cancellation")}
              variant="text"
              sx={{ textTransform: "none" }}
            >
              Terms & Conditions
            </Button>
          </Grid>

          {/* Second Row */}
          <Grid item xs={6} lg={3}>
            <Button
              onClick={() => handleOpenModal("shipping")}
              variant="text"
              sx={{ textTransform: "none" }}
            >
              Shipping Policy
            </Button>
          </Grid>

          {/* Contact Button */}
          <Grid item xs={6} lg={3}>
            <Button
              onClick={() => handleOpenModal("contact")}
              variant="text"
              color="primary"
              sx={{ textTransform: "none" }}
            >
              Contact Us
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              onClick={() => handleOpenModal("returnpolicy")}
              variant="text"
              sx={{ textTransform: "none" }}
            >
              Return and Refund Policy
            </Button>
          </Grid>
        </Grid>
      </footer>

      {[
        "terms",
        "cancellation",
        "contact",
        "shipping",
        "returnpolicy",
        "contact",
      ].map((modal) => (
        <Modal
          key={modal}
          open={openModal === modal}
          onClose={handleCloseModal}
          aria-labelledby={`${modal}-modal-title`}
        >
          <Box sx={modalStyles}>
            <IconButton
              aria-label="close"
              onClick={handleCloseModal}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
            {modalContent[modal]}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                variant="contained"
                onClick={handleCloseModal}
                sx={{ textTransform: "none" }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      ))}
    </Container>
  );
};

const styles = {
  footer: {
    padding: "0px",
    textAlign: "center",
    backgroundColor: "#fff",
    borderTop: "1px solid #ccc",
    marginTop: "30px",
    marginBottom: "30px",
  },
  line: {
    marginBottom: "10px",
  },
  iconsRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    marginBottom: "10px",
  },
  iconLink: {
    display: "flex",
    alignItems: "center",
    color: "#333",
    textDecoration: "none",
    fontSize: "14px",
  },
  icon: {
    marginRight: "5px",
    fontSize: "25px",
    color: "red",
  },
  linksRow: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
  },
};

export default Footer;
